import React from 'react';
import { motion } from 'framer-motion';
type PageHeaderProps = {
  eyebrow: string;
  title: string;
  description?: string;
};
export function PageHeader({
  eyebrow,
  title,
  description
}: PageHeaderProps) {
  return <section className="w-full bg-ink-950 py-16 lg:py-20" data-id="element-80" data-mp="3rdkn77vvyg6i">
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.45,
      ease: 'easeOut'
    }} className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-81" data-mp="3mfj1ef72s2rc">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-brass-400" data-id="element-82" data-mp="2trdhfunuihsk">
          {eyebrow}
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-3xl leading-tight text-ivory sm:text-4xl lg:text-[42px]" data-id="element-83" data-mp="38gt3ixcflz1x">
          {title}
        </h1>
        {description && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300" data-id="element-84" data-mp="2fyx9qgk01vlb">
            {description}
          </p>}
      </motion.div>
    </section>;
}